// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"142aebb5","898":"25266be9"}[chunkId] + ".chunk.css";
};